import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { GetBillTosApiParameter, GetShipTosApiParameter } from "@insite/client-framework/Services/CustomersService";
import { BillToCollectionModel, ShipToCollectionModel } from "@insite/client-framework/Types/ApiModels";
import SpirePagination, { PaginationPresentationProps } from "@insite/mobius/Pagination";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { ChangeEvent } from "react";

import { css } from "styled-components";

interface OwnProps {
    dataView: any;
    setParameter: (parameter: any) => void;
    parameter: GetBillTosApiParameter | GetShipTosApiParameter;
}

export interface PaginationStyles {
    paginationWrapper?: InjectableCss;
}

const paginationStyles: PaginationStyles = {};

const styles = paginationStyles;

const PaginationCustomer = ({ dataView, setParameter, parameter }: OwnProps) => {
    const changePage = (newPageIndex: number) => {
        setParameter({
            ...parameter,
            page: newPageIndex,
        });
    };

    const changeResultsPerPage = (event: ChangeEvent<HTMLSelectElement>) => {
        const newPageSize = parseInt(event.currentTarget.value, 10);

        setParameter({
            ...parameter,
            page: 1,
            pageSize: newPageSize,
        });
    };

    if (!dataView) {
        return null;
    }
    const { pagination } = dataView;
    if (!pagination || pagination.totalItemCount === 0) {
        return null;
    }

    return (
        <SpirePagination
            resultsCount={pagination.totalItemCount}
            currentPage={pagination.page}
            resultsPerPage={pagination.pageSize}
            resultsPerPageOptions={[9, 18, 27, 36]}
            onChangePage={changePage}
            onChangeResultsPerPage={changeResultsPerPage}
        />
    );
};

export default PaginationCustomer;
